<!--
Author: Lsc
Date: 2019-08-07
Desc: 预约购买组件
-->
<template>
    <div class="comp-order-buy comp">
        <el-form
            v-show="!orderSuccess"
            ref="fundInfo"
            :model="fundInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item label="基金名称：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.fundname+'('+ fund.fundcode +')' }}
                </div>
            </el-form-item>
            <el-form-item v-if="fund.payway" label="支付方式：" prop="way" class="form-text">
                <el-radio-group v-model="fundInfo.way">
                    <el-radio v-if="fund.payway.indexOf('2')>-1" label="2" name="sell">
                        银行卡
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="支付渠道：" prop="pay" class="payway-list">
                <el-select
                    v-if="bankLists.length > 0"
                    v-model="fundInfo.pay"
                    placeholder="请选择支付方式"
                    :class="{'hasVal':bankInfo && bankInfo.label}"
                    v-on:change="bankSel"
                >
                    <el-option-group
                        v-for="(group,index) in bankLists"
                        :key="index"
                        :label="group.label"
                        class="bank-sel"
                    >
                        <el-option
                            v-for="item in group.options"
                            :key="item.moneyaccount"
                            :label="item.label"
                            :value="item.moneyaccount"
                        >
                            <div v-if="!item.bankAdd" class="bank-info">
                                <img :src="$util.getImg(item.bankid)">
                                <span>{{ item.label }}</span>
                                <p v-if="!item.bankAdd">
                                    {{ item.text }}
                                </p>
                            </div>
                            <div v-if="item.bankAdd" class="option-group clear">
                                {{ item.bankCate }}<el-button
                                    type="blue"
                                    v-on:click.prevent="$router.push({name:'addbank'})"
                                >
                                    {{ item.bankAdd }}
                                </el-button>
                            </div>
                        </el-option>
                    </el-option-group>
                </el-select>
                <div v-if="bankInfo && bankInfo.label" class="el-select-img">
                    <img
                        :src="$util.getImg(bankInfo.bankid)"
                    >
                    <span class="k-text-flow">{{ bankInfo.label }}</span>
                </div>
                <el-radio-group v-if="bankLists.length === 0" class="bank-radio">
                    <el-radio label="no-selec" border>
                        <div class="bank-img-sel">
                            <div class="k-text-flow">
                                您的还未添加银行卡，请立即<span
                                    class="like-a"
                                    v-on:click="$router.push({name:'addbank'})"
                                >前往添加</span>
                            </div>
                        </div>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="扣款日期：" prop="bookingdate">
                <date-picker :date="dateSet" v-on:date-get="dateInterval" />
            </el-form-item>
            <el-form-item v-show="fund.sharetype === 'A,B'" label="收费方式：" prop="way" class="form-text">
                <el-radio-group v-model="fundInfo.sharetype">
                    <el-radio label="A" name="share">
                        前收费
                    </el-radio>
                    <el-radio label="B" name="share">
                        后收费
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="预约金额：" prop="amount">
                <el-input
                    v-model.trim="fundInfo.amount"
                    class="prefix"
                    :placeholder="pla"
                    :maxlength="14"
                    prefix-icon="fa fa-jpy"
                />
            </el-form-item>
            <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd" :class="{'form-text':fund.sign}">
                <el-input
                    v-model.trim="fundInfo.pwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="16"
                />
                <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
            </el-form-item>
            <el-form-item>
                <div style="width:50%;">
                    <el-button
                        type="primary"
                        class="medium"
                        :disabled="time>0"
                        v-on:click="submitInfo('fundInfo')"
                    >
                        立即预约
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </div>
            </el-form-item>
        </el-form>
        <fund-protocol v-model="protocol" :fund="fund" v-on:all-read="buyFund" />
        <result v-if="orderSuccess" :active="2" :result="result" v-on:return-page="reset" v-on:return-login="$router.push({name:'myorder'})" />
    </div>
</template>
<script>
import result from "@/components/layout/result";
import fundProtocol from "@/components/form/fundProtocol";
import datePicker from "@/components/form/datePicker.vue";
import format from "date-fns/format";
export default {
    name: "Buy",
    components: {
        result,
        fundProtocol,
        datePicker
    },
    data () {
        return {
            // 表单信息
            fundInfo: {
                amount: "",
                way: "",
                pay: "",
                sharetype: "",
                pwd: "",
                bookingdate: ""
            },
            isPwdCheck: false, // 是否校验密码
            pla: "请输入起购金额",
            orderSuccess: false, // 购买状态
            result: {// 结果页面信息
                cla: "register-success",
                msg: "您的预约申请已提交成功！",
                btnMsg: "预计11月30日以11月29日净值确认份额，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "继续预约",
                    event: "return-page"
                },
                btnR: {
                    text: "查看交易记录",
                    event: "return-login"
                }
            },
            query: null,
            time: 0, // 发送短信倒计时
            fund: {}, // 基金信息获取
            protocol: false,
            bankLists: [], // 银行卡列表
            limit: { text: "起购金额范围为：", min: "0", max: "0" }, // 限额
            rules: {// 校验规则配置
                amount: [
                    { validator: this.amountLimit, trigger: "blur" }
                ],
                pay: [
                    { validator: this.validatePayWay, trigger: "change" }
                ],
                bookingdate: [
                    { required: true, message: "请选择扣款日期", trigger: "blur" }
                ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            bankInfo: {}, // 校验银行卡信息
            cfmdate: "", // 确认日期
            dateSet: { type: "1", min: format(new Date(), "YYYY-MM-DD"), max: format(new Date(new Date().getTime() + 36 * 24 * 365 * Math.pow(10,5)), "YYYY-MM-DD"), val: "",text: "请选扣款日期" }
        };
    },
    watch: {
        "fundInfo.amount" (val) {
            this.isAmount(val);
        }
    },
    mounted () {
        this.fund = this.$route.query;
        this.isPwdCheck = this.$cache.getPwdCheck("20,22");
        this.getBuyWay();
    },
    methods: {
        validatePayWay (rule, value, callback) {
            if (this.bankLists.way === "2" && this.bankLists.length > 0) {
                callback(new Error("请选择支付方式"));
            } else {
                callback();
            }
        },
        // 再次购买重置表单
        reset () {
            this.orderSuccess = false;
            this.bankInfo = {};
            this.$set(this.fundInfo, "way", "");
            this.$set(this.fundInfo, "amount", "");
            this.getBuyWay();
        },
        // 处理限额
        amountLimit (rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 处理金额
        isAmount (val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
            }, 1);
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            this.$children[1].index = 0;
            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    _this.$util.getSdxProtocol(_this.fund,(res)=>{
                        _this.fund = res;
                        _this.protocol = true;
                    });
                } else {
                    return false;
                }
            });
        },
        buyFund(val){
            this.protocol = false;
            if(!val)return;
            const _this = this;
            // 默认参数
            let data = {
                fundcode: _this.fund.fundcode,
                amount: _this.fundInfo.amount,
                moneyaccount: _this.bankInfo.moneyaccount,
                channelid: _this.bankInfo.value,
                bookingdate: _this.fundInfo.bookingdate,
                riskwarnflag: _this.fund.riskwarnflag,
                riskmismatchflag: _this.fund.riskmismatchflag,
                highriskwarnflag: _this.fund.highriskwarnflag,
                fundmismatchflag: _this.fund.fundmismatchflag,
                tradepwd: _this.$util.enc(_this.fundInfo.pwd)
            };
            let _url = "booking/buy/order";
            // 预约下单
            _this.$util.request(_url, data, "POST").then(res => {
                if (res.data) {
                    _this.cfmdate = (res.data && res.data[0]) ? res.data[0].incomecaldate : "";
                }
                _this.resultMes(res);
            });
        },
        // 获取对应银行卡信息
        bankSel (val) {
            const _this = this;
            for (const group of this.bankLists) {
                if (group.options && group.options.length > 0) {
                    for (const bank of group.options) {
                        if (bank.moneyaccount === val) {
                            _this.bankInfo = bank;
                            break;
                        }
                    }
                }
            }
        },
        //获取银行渠道信息
        getBuyWay () {
            const _url = "trade/buy/buyinfo";
            let _param = { fundcode: this.fund.fundcode, booking: "1" };
            this.$util.request(_url, _param).then(res => {
                if (res.data) {
                    this.fund = Object.assign({}, this.fund, res.data[0][0]);
                    this.$set(this.dateSet, "max", format(this.fund.bookingmdate, "YYYY-MM-DD"));
                    this.$set(this.fundInfo, "way", "2");
                    this.$set(this.fundInfo, "sharetype", this.fund.sharetype.substr(0, 1));
                    this.bankLists = res.data[2].length > 0 ? this.$util.getBankArr(res.data[2]) : [];
                }
                this.getBank();
            });
        },
        // 切换为银行卡支付时数据初始化
        getBank () {
            // 获取银行卡信息
            const _x = this.bankLists[0] ? this.bankLists[0].options[1].moneyaccount : "";
            if (_x) {
                this.$set(this.fundInfo, "pay", _x);
                this.bankSel(_x);
            }
            this.$set(this.limit, "min", this.fund.min);
            this.$set(this.limit, "max", this.fund.max);
            this.pla = this.$util.fmtNum(this.fund.min) + "元起，最多可投" + this.$util.fmtNum(this.fund.max) + "元";
        },
        // 生成确认信息
        resultMes (res) {
            if (res.data) {
                this.result.cla = "register-success";
                this.result.btnMsg = "如遇节假日则顺延，请耐心等待";
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + res.msg;
            }
            this.result.msg = "您的预约申请受理" + (this.result.cla === "register-fail" ? "失败" : "成功");
            this.orderSuccess = true;
        },
        dateInterval (val) {
            this.fundInfo.bookingdate = val !== null ? val.replace(/-/g, "") : "";
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-order-buy {
    padding-bottom: 30px;
    .pwdForm .el-form-item.form-text {
        margin-bottom: 10px;
    }
    .pwdForm .el-form-item.form-nor {
        margin-bottom: 20px;
    }
}
</style>
